import { useQuery } from "@tanstack/react-query";
import { getUserById } from "../api";

export const useGetUserById = (userId: string) => {
  const { data, isLoading } = useQuery({
    queryKey: ["USER_ID", userId],
    queryFn: () => getUserById(userId),
    select: ({ data }) => data,
    enabled: !!userId,
  });
  return { User: data, isLoading };
};
